<div class="container-fluid py-4">
  <div class="row justify-content-center">
    <div
      class="col-4 col-md-2"
      *ngFor="let card of resumenCardsTwo; index as i"
    >
      <!-- [class]="i < 2 ? 'col-md-6' : 'col-md-4'" -->
      <div
        class="card card-stats"
        [ngClass]="{ 'card-stats__selected': i === 1 }"
        [routerLink]="card.route"
        [style.cursor]="card.route ? 'pointer' : 'default'"
      >
        <div class="card-body">
          <div class="row">
            <div class="col-12 col-md-7 col-lg-6">
              <div
                class="icon-big text-center text-dark rounded shadow"
                [ngClass]="card.bgClass"
              >
                <i [class]="card.icon"></i>
              </div>
            </div>
            <div class="col-7 d-flex flex-column justify-content-center">
              <p class="card-category mb-0">{{ card.label }}</p>
              <h4
                class="card-title mb-0"
                [ngClass]="{ 'text-dark': i === 1, 'text-white': i !== 1 }"
              >
                <!-- {{ card.value }} -->
              </h4>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <div class="stats">
            <small [class]="i == 1 ? 'desc__selected' : 'desc'">{{
              card.desc
            }}</small>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row justify-content-center">
    <div class="col-3 col-md-2" *ngFor="let card of resumenCards; index as i">
      <!-- [class]="i < 2 ? 'col-md-6' : 'col-md-4'" -->
      <div
        class="card card-stats"
        [ngClass]="{ 'card-stats__selected': i === 3 }"
        [routerLink]="card.route"
        [style.cursor]="card.route ? 'pointer' : 'default'"
      >
        <div class="card-body">
          <div class="row">
            <div class="col-12 col-md-6 col-lg-5">
              <div
                class="icon-big text-center text-dark rounded shadow"
                [ngClass]="card.bgClass"
              >
                <i [class]="card.icon"></i>
              </div>
            </div>
            <div class="col-7 d-flex flex-column justify-content-center">
              <p class="card-category mb-0">{{ card.label }}</p>
              <h4
                class="card-title mb-0"
                [ngClass]="{ 'text-dark': i === 3, 'text-white': i !== 3 }"
              >
                {{ card.value }}
              </h4>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <div class="stats">
            <small [class]="i == 3 ? 'desc__selected' : 'desc'">{{
              card.desc
            }}</small>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Campo de búsqueda mejorado con autocompletado -->
  <div class="row mb-3">
    <div class="col-md-4">
      <div class="input-group">
        <input
          type="text"
          class="form-control"
          placeholder="Search ..."
          [(ngModel)]="searchText"
          (ngModelChange)="filterInfo()"
          list="sugerenciasConductores"
          autocomplete="off"
        />
        <span class="input-group-text bg-transparent"
          ><i class="fas fa-search text-dark"></i
        ></span>
        <datalist id="sugerenciasConductores">
          <option
            *ngFor="let sugerencia of sugerenciasBusqueda"
            [value]="sugerencia"
          ></option>
        </datalist>
      </div>
    </div>
  </div>
  <div class="card-tools">
    <a
      [checkPerms]="'/accountings/add'"
      [routerLink]="['/numbers/accounting/external/add']"
      class="btn btn-dark btn-sm btn-new"
    >
      Add a bill
    </a>
    <a [routerLink]="['/numbers/accounting']" class="btn btn-dark btn-sm btn-new">
      Staff
    </a>
    <a
      [routerLink]="['/numbers/accounting/freelancers']"
      class="btn btn-dark btn-sm btn-new"
    >
      Freelancers
    </a>
    <a
      [routerLink]="['/numbers/accounting/drivers']"
      class="btn btn-dark btn-sm btn-new"
    >
      Driver & +
    </a>
    <a
      [routerLink]="['/numbers/accounting/customers']"
      class="btn btn-dark btn-sm btn-new"
    >
      Customers
    </a>
  </div>
  <div class="card shadow-sm">
    <div class="card-body p-0">
      <div class="table-responsive">
        <table class="table table-bordered table-striped">
          <thead class="thead">
            <tr>
              <th>
                <strong>{{ year }}</strong>
              </th>
              <th><strong>ONE TIME</strong></th>
              <!-- <th><strong>DAILY</strong></th>
              <th><strong>WEEKLY</strong></th> -->
              <th><strong>MONTHLY</strong></th>
              <th><strong>YEARLY</strong></th>
              <th><strong>TOTAL</strong></th>
              <th class="th__status"><strong>ACTIONS</strong></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of filteredData">
              <td *ngIf="redirect">
                <!-- <a
                  [routerLink]="['/numbers/accounting/personnel/edit', item.personnel]"
                  class="btn btn-link btn-sm p-2 a--personnel"
                >
                  {{ findPersonnel(item.personnel) }}</a
                >/{{ item.description }}
              </td> -->
              </td>

              <td>{{ item.description }}</td>
              <td>{{ item.oneTime }}</td>
              <!-- <td>{{ item.daily }}</td>
              <td>{{ item.week }}</td> -->
              <td>{{ item.monthly }}</td>
              <td>{{ item.yearly }}</td>
              <td></td>
              <td class="d-flex text-center">
                <a
                  [routerLink]="['/numbers/accounting/external/edit', item._id]"
                  class="btn btn-link text-dark btn-sm p-2 btn--updel"
                >
                  <i class="fas fa-edit"></i>
                </a>
                <!-- <a
                  *ngIf="redirect"
                  [routerLink]="['/numbers/accounting/internal/edit', item._id]"
                  class="btn btn-link text-dark btn-sm p-2 btn--updel"
                >
                  <i class="fas fa-edit"></i>
                </a> -->
                <button
                  (click)="deleteData(item._id)"
                  class="btn btn-link text-dark btn-sm p-2 btn--updel"
                >
                  <i class="fas fa-trash"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="row">
        <div class="col-md-6">
          <button
            class="btn btn-dark btn-sm btn-initial"
            (click)="prevPage()"
            [disabled]="currentPage === 1"
          >
            <
          </button>
          <label>&nbsp;&nbsp;{{ currentPage }}&nbsp;&nbsp;</label>
          <button
            class="btn btn-dark btn-sm btn-initial"
            (click)="nextPage()"
            [disabled]="!morePages"
          >
            >
          </button>
        </div>
        <div class="col-md-6">
          <h2 for="">Total : {{ total }}</h2>
        </div>
      </div>
    </div>
  </div>
</div>
